<script setup>
import {ref} from "vue";

const activeItems = ref([{
  "name": "中信银行联名卡",
  "url": "https://cdn-mfemas.xiamenair.com/cms_mobile/land/zhongxinyinhangxiahanglianmingbaijinka.html",
  "jingle": "最高每消费10元人民币累积1白鹭积分",
  "img": require("@/assets/images/tm/zxyh.png")
}, {
  "name": "平安银行联名卡",
  "url": "https://b.pingan.com.cn/kuaizhan/v2/5K1500/20240508/k91182/index.html?campaignid=202405051926",
  "jingle": "最高每12信用卡积分转化1白鹭积分",
  "img": require("@/assets/images/tm/payh.jpg")
}, {
  "name": "同程旅行",
  "url": "https://m.elong.com/hotel/?&isEntryBack=true",
  "jingle": "同程里程兑换白鹭积分",
  "img": require('@/assets/images/tm/tclx.png')
}, {
  "name": "携程旅行",
  "url": "https://m.ctrip.com/webapp/flightcms/active/642b756c077c6c8d20233c7f1a76cc3e",
  "jingle": "携程积分兑换厦航积分",
  "img": require("@/assets/images/tm/xclx.png")
}])
defineProps({
  banner: {
    type: String,
    default: 'https://images.jifen360.com/tm_mark/active-xm.png'
  }
})

const openPage = (url) => {
  window.open(url)
}
</script>

<template>
  <div class="active-items">
    <el-image :src="banner"/>
    <div class="active-lst">
      <div class="active-item" v-for="i in activeItems" :key="i">
        <div class="active-info" @click="openPage(i.url)">
          <el-image :src="i.img" style="width: 100%;margin-bottom: 10px"/>
          <h4>{{ i.name }}</h4>
          <el-text type="info">{{ i.jingle }}</el-text>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.active-items {
  margin: 15px;

  .active-lst {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;

    .active-item {
      flex: 0 0 50%;
      width: 50%;
      margin-bottom: 10px;
      ///* 防止内容被拆分到不同列 */
      box-sizing: border-box;
      padding: 5px;

      .active-info {
        background: #F5F5F5;
        border-radius: 8px;
        overflow: hidden;
        padding: 10px;
        //height: 100%;
      }
    }
  }
}
</style>
